module.exports = __webpack_public_path__ + "assets/img/0609.12e63999.svg";